import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { appConfig, AuthGaurdService } from './auth-gaurd.service';
import { CalendarModel } from '../models/config/calendar.model';
import { PayrollReport } from '../models/reports/payroll-report.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { AddUser } from '../models/manageUsers/add-user.model';

@Injectable({
    providedIn: 'root'
})
export class CalendarService {

    private host = environment.apiUrl + "config/calendar";
    private host_cal_type = environment.apiUrl + "config/calendartype";
    public loggedinUser: string = '';

    selectedCalcModel = new CalendarModel(0, '', null, null, null, null, '', '', '', '', null, '', null, '', false, null, '','','');

    constructor(private http: HttpClient,
        private logger: LoggerService, private authGaurdService: AuthGaurdService) {
        this.loggedinUser = this.authGaurdService.loginUser();
        console.log("this.loggedinUser: " + this.loggedinUser);
    }

    public addCalendarType(formData: FormData): Observable<CalendarModel> {
        return this.http.post<CalendarModel>(`${this.host_cal_type}/addcalendartype`, formData);
    }

    public updateCalendarType(formData: FormData): Observable<CalendarModel> {
        return this.http.post<CalendarModel>(`${this.host_cal_type}/updatecalendartype`, formData);
    }

    public getCalList() {
        let url = this.host_cal_type + '/getcalendarlist';
        return this.http.get<CalendarModel[]>(url)
            .pipe(
                map((data: CalendarModel[]) => {
                    return data;
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public updateStatusToActive(calendarModel: CalendarModel[]) {
        let url = this.host_cal_type + '/updatestatustoactive';
        let body = calendarModel ? JSON.stringify(calendarModel) : '';
        return this.http.put(url, body, appConfig.httpOptions)
            .pipe(
                catchError(this.handleError)
            )
    }

    public updateStatusToInactive(calendarModel: CalendarModel[]) {
        let url = this.host_cal_type + '/updatestatustoinactive';
        let body = calendarModel ? JSON.stringify(calendarModel) : '';
        return this.http.put(url, body, appConfig.httpOptions)
            .pipe(
                catchError(this.handleError)
            )
    }

    public updateCalcs(calendarModel: CalendarModel[]) {
        let url = this.host + '/updatecalc';
        let body = calendarModel ? JSON.stringify(calendarModel) : '';
        return this.http.put(url, body, appConfig.httpOptions)
            .pipe(
                catchError(this.handleError)
            )
    }

    public getCalc(calendar_type: string) {
        let url = this.host + '/getcalc/' + calendar_type;
        return this.http.get<CalendarModel[]>(url)
            .pipe(
                map((data: CalendarModel[]) => {
                    return data;
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public getUserRoles() {
        let url = this.host + '/getuserroles';
        return this.http.get<AddUser[]>(url)
            .pipe(
                map((data: AddUser[]) => {
                    return data;
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public getCalData() {
        let url = this.host + '/getcalendardata';
        return this.http.get<CalendarModel[]>(url)
            .pipe(
                map((data: CalendarModel[]) => {
                    const seen = new Set<string>();
                    const currentYearMonth = new Date().getFullYear() * 100 + (new Date().getMonth() + 1);
                    return (data || [])
                        .filter(item => {
                            const key = item?.cal_run_id != null ? String(item.cal_run_id) : '';
                            if (!key || seen.has(key)) {
                                return false;
                            }
                            const calRunId = Number(key);
                            if (!Number.isNaN(calRunId) && calRunId > currentYearMonth) {
                                return false;
                            }
                            seen.add(key);
                            return true;
                        })
                        .sort((a, b) => Number(b.cal_run_id) - Number(a.cal_run_id));
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public addPayrollCalendar(formData: FormData): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host}/addpayrollcalendar`, formData);
    }

    public getCalRunIdsDropdown(): Observable<CalendarModel[]> {
        return this.http.get<CalendarModel[]>(`${this.host}/getcalrunidsdropdown`);
    }

    public getCalenarTypes() {
        let url = this.host + '/getcalendartypes';
        return this.http.get<CalendarModel[]>(url)
            .pipe(
                map((data: CalendarModel[]) => {
                    return data;
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public getCommPeriodValues(calType: string) {
        let url = this.host + '/getcommperiodvalues/' + calType;
        return this.http.get<CalendarModel[]>(url)
            .pipe(
                map((data: CalendarModel[]) => {
                    return data;
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public getCommPeriodUnlockValues(calType: string) {
        let url = this.host + '/getcommperiodvalbyunlock/' + calType;
        return this.http.get<CalendarModel[]>(url)
            .pipe(
                map((data: CalendarModel[]) => {
                    return data;
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public getPayrollReportByCalrun(calRunId: string) {
        let url = this.host + '/getpayrollreport/' + calRunId;
        return this.http.get<PayrollReport[]>(url)
            .pipe(
                map((data: PayrollReport[]) => {
                    return data;
                }), catchError(error => {
                    this.logger.info(' error ==> ', error);
                    return throwError('Something went wrong!');
                })
            )
    }

    public createForm(calendarModel: CalendarModel, calendar_type: string): FormData {
        const formData = new FormData();


        var valid_from_dt = (new Date(calendarModel.valid_from_dt)).toUTCString();
        var valid_to_dt = (new Date(calendarModel.valid_to_dt)).toUTCString();
        var payroll_due_dt = (new Date(calendarModel.payroll_due_dt)).toUTCString();
        var pay_dt = (new Date(calendarModel.pay_dt)).toUTCString();

        console.log("valid_from_dt: " + valid_from_dt);

        formData.append('valid_from_dt', valid_from_dt);
        formData.append('valid_to_dt', valid_to_dt);
        formData.append('payroll_due_dt', payroll_due_dt);
        formData.append('pay_dt', pay_dt);
        formData.append('unlock', calendarModel.unlock);
        formData.append('issalesrepaccess', calendarModel.issalesrepaccess);
        formData.append('off_cycle', calendarModel.off_cycle);
        formData.append('cal_run_id', calendarModel.cal_run_id);
        formData.append('calendar_type', calendar_type);
        formData.append('current_user', this.loggedinUser);

        return formData;
    }

    public createCalTypeForm(calendarModel: CalendarModel): FormData {
        const formData = new FormData();

        formData.append('id', calendarModel.id);
        formData.append('calendar_type', calendarModel.calendarType);
        formData.append('active_flag', calendarModel.active_flag);
        formData.append('currentUser', this.loggedinUser);

        return formData;
    }

     /**
     * Check if a given effective date falls within a locked period (unlock = 'N')
     * @param effectiveDate The effective date to check
     * @param calendarData Array of calendar data from calendar-update
     * @returns boolean - true if the date is in a locked period, false otherwise
     */
    public isDateInLockedPeriod(effectiveDate: Date, calendarData: CalendarModel[]): boolean {
        if (!effectiveDate || !calendarData || calendarData.length === 0) {
            return false;
        }

        const checkDate = new Date(effectiveDate);
        
        for (const calendar of calendarData) {
            // Check if unlock is 'N' (locked)
            if (calendar.unlock === 'N') {
                const validFromDate = new Date(calendar.valid_from_dt);
                const validToDate = new Date(calendar.valid_to_dt);
                
                // Check if the effective date falls within this locked period
                if (checkDate >= validFromDate && checkDate <= validToDate) {
                    return true;
                }
            }
        }
        
        return false;
    }

    public handleError(error: { error: { message: string; }; status: any; message: any; }) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        window.alert(errorMessage);
        return throwError(errorMessage);
    }
}


